import { createContext, useContext, useEffect, useState } from "react";

const EnquiryContext = createContext();

export const EnquiryProvider = ({ children }) => {
  const [enquiries, setEnquiries] = useState(() => {
    const stored = localStorage.getItem("enquiries");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem("enquiries", JSON.stringify(enquiries));
  }, [enquiries]);

  const addEnquiry = (data) => {
    const newEnquiry = {
      id: Date.now(),
      ...data,
      visitDate: new Date().toLocaleDateString(),
    };

    setEnquiries((prev) => [...prev, newEnquiry]);
  };

  const deleteEnquiry = (id) => {
    setEnquiries((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <EnquiryContext.Provider
      value={{ enquiries, addEnquiry, deleteEnquiry }}
    >
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);